import { toShortDate } from "@api/date";
import { CreatedBy } from "@components/backoffice/ChangedBy";
import { DetailsHeader } from "@components/backoffice/DetailsHeader";
import { RestrictedAccessLabel } from "@components/backoffice/RestrictedAccessLabel";
import { CopyButton } from "@components/CopyButton";
import { invenioConfig } from "@config";
import DocumentAuthors from "@modules/Document/DocumentAuthors";
import LiteratureCover from "@modules/Literature/LiteratureCover";
import LiteratureTags from "@modules/Literature/LiteratureTags";
import LiteratureTitle from "@modules/Literature/LiteratureTitle";
import { FrontSiteRoutes } from "@routes/urls";
import _get from "lodash/get";
import { DateTime } from "luxon";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Header, Icon, Label } from "semantic-ui-react";
import UnflagButton from "@components/backoffice/buttons/UnflaggedButton/UnflagButton";

export class DocumentHeader extends Component {
  state = {
    isLocallyUnflagged: false,
  };

  handleUnflagSuccess = (data, documentPid) => {
    this.setState({ isLocallyUnflagged: true });
  };

  renderWeedingStatus() {
    const { data } = this.props;
    const { isLocallyUnflagged } = this.state;

    if (!data.metadata?.weeding?.is_flagged || isLocallyUnflagged) {
      return null;
    }

    return (
      <Label basic color="red" size="small" style={{ marginRight: "0.5em" }}>
        <Icon name="flag" />
        Flagged for deletion
      </Label>
    );
  }

  renderWeededOutStatus() {
    const { data } = this.props;

    if (data.metadata?.weed_out === true) {
      return (
        <Label color="red" size="small" style={{ marginBottom: "0.5em" }}>
          <Icon name="ban" />
          REMOVED
        </Label>
      );
    }
    return null;
  }

  renderExemptButton() {
    const { data } = this.props;
    const { isLocallyUnflagged } = this.state;

    if (!data.metadata?.weeding?.is_flagged || isLocallyUnflagged) {
      return null;
    }

    return (
      <UnflagButton
        documentPid={data.metadata.pid}
        size="small"
        showText
        onSuccess={this.handleUnflagSuccess}
      />
    );
  }

  render() {
    const { data } = this.props;
    const recordInfo = (
      <>
        <label className="muted">Document</label> {data.metadata.pid}{" "}
        <CopyButton text={data.metadata.pid} />
        {data.metadata.created_by && (
          <>
            <br />
            <label className="muted">Created by</label>{" "}
            <CreatedBy metadata={data.metadata} />
          </>
        )}
        <br />
        <label className="muted">Created on</label>{" "}
        {toShortDate(DateTime.fromISO(data.created))}
        <br />
        <RestrictedAccessLabel isRestricted={data.metadata.restricted} />
        <Label
          as={Link}
          to={FrontSiteRoutes.documentDetailsFor(data.metadata.pid)}
          color="grey"
          style={{ marginBottom: "10px" }}
        >
          <Icon name="linkify" />
          View in Frontsite
        </Label>
        <br />
        {this.renderExemptButton()}
      </>
    );
    const volume = _get(
      data,
      "metadata.relations.multipart_monograph[0].volume"
    );
    return (
      <DetailsHeader
        title={
          <>
            <div>{this.renderWeededOutStatus()}</div>
            <Header.Subheader className="bo-details-subheader">
              {data.metadata.document_type}
            </Header.Subheader>

            <div style={{ fontSize: "25px" }}>
              <LiteratureTitle
                title={data.metadata.title}
                edition={data.metadata.edition}
                publicationYear={data.metadata.publication_year}
                volume={volume}
                truncate={false}
              />
            </div>
          </>
        }
        subTitle={
          <DocumentAuthors
            authors={data.metadata.authors || []}
            hasOtherAuthors={data.metadata.other_authors}
            prefix="by "
            limit={invenioConfig.LITERATURE.authors.maxDisplay}
          />
        }
        pid={data.metadata.pid}
        image={
          <LiteratureCover
            size="super-tiny"
            url={_get(data, "metadata.cover_metadata.urls.medium")}
          />
        }
        recordInfo={recordInfo}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: "0.5em",
          }}
        >
          {this.renderWeedingStatus()}
          <LiteratureTags tags={data.metadata.tags} />
        </div>
      </DetailsHeader>
    );
  }
}

DocumentHeader.propTypes = {
  data: PropTypes.object.isRequired,
};
